import { connect } from 'react-redux';
import ApplicationStatus from './Applications';
import centredForm from '../components/centredForm';
import {
  getApps,
  getViewableApplications,
  isFetching,
  getError,
  getFilters,
  getPagination,
} from '../../../state/reducers/ApplicationReducer';
import { getError as getConfigError } from '../../../state/reducers/ConfigReducer';
import {
  getPermissions,
  isLAO,
  getCurrentUserAssignmentId,
} from '../../../state/reducers/LoginReducer';
import ApplicationActions from '../../../state/actions/ApplicationActions';

const mapStateToProps = (state) => ({
  isLAO: isLAO(state),
  currentUserAssignmentId: getCurrentUserAssignmentId(state),
  applications: isLAO(state) ? getApps(state) : getViewableApplications(state),
  isFetching: isFetching(state),
  filters: getFilters(state),
  pagination: getPagination(state),
  error: getError(state) || getConfigError(state),
  permissions: getPermissions(state),
});

const {
  getApplicationsRequest,
  setFilters,
  setApplication,
  clearCurrentApplication,
} = ApplicationActions;

const Page = centredForm(ApplicationStatus, '', 350);

export default connect(mapStateToProps, {
  getApplications: getApplicationsRequest,
  setApplication,
  setFilters,
  clearCurrentApplication,
})(Page);



// WEBPACK FOOTER //
// ./src/view/scenes/Applications/index.js